<template>
  <div class="search-content">
      <router-view />
  </div>
</template>

<script>
  export default {
    name: 'SettingLayout',
    data () {
      return {
        tabs: {
          items: [
            {
              key: '1',
              title: '赛区汇总'
            },
            {
              key: '2',
              title: '单位汇总'
            },
          ],
          active: () => {
            switch (this.$route.path) {
              case '/sai/CaiwuSaiquList':
                return '1'
//              case '/sai/SaijiList':
              case '/sai/CaiwuDanweiList':
                return '2' 
              default:
                return '1'
            }
          },
          callback: (key) => {
            switch (key) {
              case '1':
                this.$router.push('/sai/CaiwuSaiquList')
                break
              case '2':
                this.$router.push('/sai/CaiwuDanweiList')
//                this.$router.push('/sai/SaijiList')
                break 
              default:
                this.$router.push('/workplace')
            }
          }
        },
        search: false
      }
    },
    computed: {

    },
    methods: {
    }
  }
</script>

<style lang="less" scoped>
  .search-head{
    background-color: #fff;
    margin: -25px -24px -24px;
    .search-input{
      text-align: center;
      margin-bottom: 16px;
    }
  }
  .search-content{
    margin-top: 0px;
  }
</style>
